import { FLYBITS, FLYBITS_HEADERS, TENANT } from '../../../constants';
import axios from '../../../utils/axios';
import { IIntegration, IProject } from '../types/project';

export const defaultProject = (): IProject => ({
    id: TENANT.NO_TENANT,
    name: TENANT.NO_TENANT_NAME,
    auth: '',
    integrations: [],
    isActive: true
})

export const getAuth = async (session: string, projectId: string): Promise<string> => {
    const endpoint = FLYBITS.PROXY_HOST + '/sso/auth/project?projectId=' + projectId;
    let auth;
    try {
        const response = (await axios.get(endpoint, {
            headers: {
                'authorization': session
            }
        }));
        if (200 === response.status) {
            auth = response.headers[FLYBITS_HEADERS.AUTH];
        }
    } catch (e) {/* tslint:disable:no-empty */}
    return auth;
}

export const getIntegrations = async (session: string, projectId: string): Promise<IIntegration[]> => {
    return [
        {
            name: 'salesforce',
            description: 'Salesforce is the leader in cloud computing, offering applications for all aspects of your business, including CRM, sales, ERP, customer service, marketing automation, business analytics, mobile application building, and much more.',
            text: 'Salesforce',
            path: 'salesforce',
            icon: 'https://assets.brandfolder.com/od3ecc-amazlc-9el8ys/original/Salesforce_Logo_RGB_1797c0_8_13_14.png'
        },
        {
            name: 'codat',
            description: 'Codat provide you with seamless integrations with the financial software used by your small business customers - all through a single API.',
            text: 'Codat',
            path: 'codat',
            icon: 'https://images.g2crowd.com/uploads/product/image/social_landscape/social_landscape_e01183acaebb76dc1e18ddc7cc70ff67/codat-api.png'
        },
        {
            name: 'datafiniti',
            description: 'Datafiniti lets you access web data without having to setup a web scraper. Targeted updates. >100m unique records.',
            text: 'Datafiniti',
            path: 'datafiniti',
            icon: 'https://images.g2crowd.com/uploads/product/image/social_landscape/social_landscape_26c6d4a9e1a685d1e0435965ff542156/datafiniti.png'
        },
        {
            name: 'hubspot',
            description: 'HubSpot. HubSpot is a developer and marketer of software products for inbound marketing and sales. Its products and services aim to provide tools for social media marketing, content management, web analytics and search engine optimization.',
            text: 'HubSpot',
            path: 'hubspot',
            icon: 'https://www.hubspot.com/hubfs/assets/hubspot.com/style-guide/brand-guidelines/guidelines_the-sprocket.svg'
        },
        {
            name: 'paymi',
            description: 'Paymi is a Canadian based cashback app that lets you earn rewards when you shop online or in-store.',
            text: 'Paymi',
            path: 'paymi',
            icon: 'https://theme.zdassets.com/theme_assets/1984112/87d4dbe2340f2d5e2b584d20c0a992562b6bc502.png'
        },
        {
            name: 'adobe',
            description: 'Adobe Audience Manager (AAM) is a powerful data management platform that helps you build unique audience profiles from first-party, second-party/partner, and third-party data integrations.',
            text: 'Adobe AM',
            path: 'adobe',
            icon: 'https://forums.adobe.com/community/image/5447/2.png?a=858707'
        },
        {
            name: 'roostify',
            description: 'Roostify is a collection of forward-thinking minds dedicated to enhancing the lending experience for everyone involved in the home buying process.',
            text: 'Roostify',
            path: 'roostify',
            icon: 'https://static1.squarespace.com/static/5c335e3ff2e6b1bd0e667c66/t/5c409e7042bfc114361653c8/1557877060139/?format=1500w'
        },
        {
            name: 'sensibill',
            description: 'Sensibill provides a turnkey digital receipt solution to the world\'s largest financial institutions. Our service allows retail customers to manage their itemized receipts from trusted financial services applications.',
            text: 'Sensibill',
            path: 'sensibill',
            icon: 'https://media.glassdoor.com/sqll/1071652/sensibill-squarelogo-1444268511795.png'
        },
        {
            name: 'radario',
            description: 'Radar helps you build better products and make better decisions with location context.',
            text: 'Radar.io',
            path: 'radario',
            icon: 'https://radar.io/static/image/logo.png'
        },
        {
            name: 'fusionfabric',
            description: 'FusionFabric.cloud is the Finastra’s Platform-as-a-Service solution to unlock innovation in financial services.',
            text: 'Fusionfabric',
            path: 'fusionfabric',
            icon: 'https://avatars3.githubusercontent.com/u/52748696?s=200&v=4'
        },
        {
            name: 'openweathermap',
            description: 'OpenWeatherMap is an online service that provides weather data, including current weather data, forecasts, and historical data to the developers of web services and mobile applications.',
            text: 'OpenWeatherMap',
            path: 'openweathermap',
            icon: 'https://upload.wikimedia.org/wikipedia/commons/1/15/OpenWeatherMap_logo.png'
        },
    ];
}




// WEBPACK FOOTER //
// ./src/sub-projects/tenant/services/project.ts